import { compartilharTexto } from "@/lib/whatsapp";
import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Copy, Share2, ExternalLink, X } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export const portalUrl = (slug) => `${window.location.origin}/portal/${slug || ""}`;

export const PortalLinkDialog = ({ cliente, onClose }) => {
  const { user } = useAuth();
  const slug = user?.empresa?.slug;
  const empresa = user?.empresa?.nome || "";
  const url = portalUrl(slug);
  const primeiro = (cliente?.nome || "").split(" ")[0];
  const [sit, setSit] = useState(null);
  useEffect(() => { if (cliente?.id) api.get(`/portal-admin/${cliente.id}/status`).then((r) => setSit(r.data)).catch(() => setSit(null)); }, [cliente?.id]);
  const legado = sit?.codigo === "nao_migrado";
  const acesso = legado ? "Entre com seu CPF e sua data de nascimento (acesso antigo, ainda habilitado para você). No primeiro acesso você criará sua senha pessoal." : "Entre com seu CPF e sua senha pessoal (ou a senha provisória que enviamos).";
  const msg = `Olá${primeiro ? ` ${primeiro}` : ""}! Acesse o Portal do Cliente${empresa ? ` da ${empresa}` : ""} para consultar seus contratos, parcelas e recibos:\n${url}\n\n${acesso}`;
  const copiar = async () => { try { await navigator.clipboard.writeText(url); toast.success("Link do portal copiado!"); } catch { toast.error("Não foi possível copiar"); } };
  const whats = () => compartilharTexto({ texto: msg, titulo: "Link do Portal do Cliente", cliente_id: cliente?.id, telefone: cliente?.whatsapp || cliente?.telefone, evento: "link_portal", categoria: "Portal" });
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="portal-link-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ExternalLink className="w-5 h-5 gold-text" /> Link do Portal do Cliente</DialogTitle>
          <DialogDescription data-testid="portal-link-orientacao">{cliente ? <>Envie para <b>{cliente.nome}</b>. Acesso principal: <b>CPF + senha pessoal</b> (ou senha provisória gerada na aba Portal).{legado && <> Este cliente ainda está no <b>acesso antigo por CPF + data de nascimento</b>; ao entrar, criará a senha pessoal.</>}{sit?.label && <span className="block mt-1 text-xs">Situação atual: {sit.label}</span>}</> : "Link público do portal desta empresa. O cliente entra com CPF + senha pessoal (ou senha provisória)."}</DialogDescription>
        </DialogHeader>
        {!slug ? <p className="text-sm text-red-600" data-testid="portal-link-sem-slug">Empresa sem identificador (slug) configurado.</p> : (
          <div className="space-y-3">
            <div className="rounded-lg bg-slate-50 border px-3 py-2 text-sm mono break-all" data-testid="portal-link-url">{url}</div>
            <div className="flex gap-2 flex-wrap">
              <Button variant="outline" onClick={copiar} className="gap-2 flex-1" data-testid="portal-link-copy"><Copy className="w-4 h-4" /> Copiar link</Button>
              {cliente && <Button onClick={whats} className="gap-2 flex-1 bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="portal-link-share"><Share2 className="w-4 h-4" /> Compartilhar</Button>}
              <Button variant="ghost" onClick={onClose} className="gap-2" data-testid="portal-link-close"><X className="w-4 h-4" /> Fechar</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
